import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { PromotedServiceAssignment } from '@mews-commander/data-access';
import { Stack, Typography } from '@optimus-web/core';
import { FormSwitchField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

import { FormFields, FormValues } from '../../schema';

import { ServiceSelectionField } from './fields';
import { ServicePromotionSettings } from './ServicePromotionSettings';

interface ServicePromotionFormProps {
    enterpriseId: string;
    serviceId: string;
    isEditMode: boolean;
    promotedService?: PromotedServiceAssignment;
}

export const ServicePromotionForm: FC<ServicePromotionFormProps> = ({
    enterpriseId,
    serviceId,
    isEditMode,
    promotedService,
}) => {
    const { watch } = useFormContext<FormValues>();

    const promotedServiceId = watch(FormFields.PromotedServiceId);

    return (
        <Stack fill vertical spacing="300">
            <FormSwitchField name={FormFields.Enabled} label={lt(TextKey.Enabled)} />
            <Typography textStyle="titleMediumStrong" as="div">
                {lt(TextKey.PromotedService)}
            </Typography>
            <ServiceSelectionField enterpriseId={enterpriseId} serviceId={serviceId} isEditMode={isEditMode} />
            {!!promotedServiceId && (
                <ServicePromotionSettings
                    serviceId={serviceId}
                    enterpriseId={enterpriseId}
                    promotedServiceId={promotedServiceId}
                    isEditMode={isEditMode}
                    promotedService={promotedService}
                />
            )}
        </Stack>
    );
};
